<template>
  <div v-if="permissionForm" class="py-8">
    <PermissionPropertiesForm :form="permissionForm" @on-save="savePermission" @on-delete="confirmDelete"/>
  </div>
</template>

<script>
import PermissionPropertiesForm from "@/Forms/Permission/PermissionPropertiesForm.vue";
import {mapStores} from "pinia";
import {usePermissionsStore} from "@/stores/permissions.js";

export default {
  name: "PermissionPropertiesView",
  components: {PermissionPropertiesForm},
  data() {
    return {
      permissionForm: undefined,
    }
  },
  emits: [
    'on-save',
    'on-delete',
  ],
  computed: {
    ...mapStores(usePermissionsStore)
  },
  methods: {
    async savePermission() {
      try {
        const response = await this.permissionForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.users.permissions.permission.properties.permission_properties_view.permission_saved'),
          life: 3000
        });
        this.$emit('on-save');
        this.$router.replace({params: {...this.$route.params, permission: response.data.id}});
      } catch (error) {
        //
      }
    },
    confirmDelete() {
      this.$confirm.require({
        group: 'delete',
        message: this.$t('pages.admin.users.permissions.permission.properties.permission_properties_view.are_you_sure_you_want_to_delete_this_permission'),
        header: this.$t('pages.admin.users.permissions.permission.properties.permission_properties_view.delete_permission'),
        accept: () => {
          this.deletePermission();
        },
        reject: () => {
          this.$toast.add({
            severity: 'info',
            summary: this.$t('common.cancelled'),
            detail: this.$t('pages.admin.users.permissions.permission.properties.permission_properties_view.permission_was_not_deleted'),
            life: 3000
          });
        }
      });
    },
    async deletePermission() {
      try {
        if (this.$route.params.permission !== 'NEW') {
          await this.permissionsStore.deletePermission(this.$route.params.permission);
          this.$emit('on-delete');
        }
        this.$router.push({name: 'admin.users.permissions', params: {...this.$route.params, permission: undefined}});
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    '$route.params.permission': {
      async handler(newValue, oldValue) {
        if (newValue) {
          if (this.$route.params.permission === 'NEW') {
            this.permissionForm = await this.permissionsStore.createPermission();
          } else {
            this.permissionForm = await this.permissionsStore.editPermission(this.$route.params.permission);
            this.permissionForm.id = this.$route.params.permission;
          }
        } else {
          this.permissionForm = undefined;
        }
      },
      immediate: true,
    }
  },
}
</script>